<template>
  <div>
    <!-- Edit -->
    <a-modal v-model="visible" title="Edit Role Detail" onOk="handleOk">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleEdit">Update Role</a-button>
      </template>
      <a-spin :spinning="spinning">
        <a-form class="mb-4" :form="form">
          <a-form-item label="Role Name">
            <a-input
              placeholder="Name"
              v-decorator="['name', {rules: [{ required: true, message: 'Please input a role name!' }]}]"
            />
          </a-form-item>
          <a-form-item label="Slug Name">
            <a-input
              placeholder="Slug name"
              v-decorator="['slug', {rules: [{ required: true, message: 'Please input a role slug!' }]}]"
            />
          </a-form-item>
          <a-form-item label="Description">
            <a-textarea placeholder="Description" :autosize="{minRows: 2}" v-decorator="['description']" />
          </a-form-item>
          <a-form-item label="Role Status">
            <!-- <a-checkbox @change="onChangeStatus" :checked="statuscheck" v-decorator="['status']">{{ this.statustext }}</a-checkbox> -->
            <a-checkbox v-model="statuscheck" v-decorator="['status']">{{ this.statustext }}</a-checkbox>
          </a-form-item>
          <permission-element :userselected="localpermissionbuffer" :data="permissiondata" @onCheckAPermission="getSelectedPermissions"></permission-element>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import PermissionElement from '@/components/role/comps/permission'

export default {
  name: 'EditRole',
  components: { PermissionElement },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      roleTypeId: null,
      statuscheck: false,
      permissiondata: [],
      localpermissionbuffer: [],
      selectedPermissions: [],
      selectedrole: [],
    }
  },
  mounted: function () {
    this.$eventBus.$on('openRoleEditModal', this.showModal)
    this.$http.get('/api/permission')
      .then((data) => {
        this.permissiondata = data.data.data
      })
      .catch(error => {
        console.error(error)
      })
  },
  computed: {
    statustext() {
      return this.statuscheck ? 'Active' : 'Not Active'
    },
  },
  methods: {
    // Todo: Should use getSelectedPermissions to received data emitted from the child component PermissionElement
    // Currently selected permissions data are received through localpermissionbuffer through watcher in userselected props. This
    // should not be the way to implement child to parent data binding.
    getSelectedPermissions: function (v) {
      this.selectedPermissions = []
      this.selectedPermissions.length = 0
      this.selectedPermissions = v
      console.log('Inside getSelectedPermissions method')
      console.log('selectedPermissions:: ', this.selectedPermissions)
    },
    onChangeStatus: function(e) {
      if (e.target.checked) {
        this.statustext = 'Active'
        this.statuscheck = true
      } else {
        this.statustext = 'Not Active'
        this.statuscheck = false
      }
    },
    showModal: function(roleTypeId) {
      this.roleTypeId = roleTypeId
      this.visible = true
      this.loading = true
      this.spinning = true
      this.$http.get('/api/school-role/' + roleTypeId).then(({ data }) => {
        this.statuscheck = data.data.status === 1
        const editData = {
          'name': data.data.name,
          'slug': data.data.slug,
          'status': data.data.status,
          'description': data.data.description,
        }
        this.selectedrole = []
        this.selectedrole.length = 0
        this.selectedrole = data.data.permissions
        console.log('selected role from server ', this.selectedrole)
        this.localpermissionbuffer = []
        this.localpermissionbuffer.length = 0
        this.selectedrole.forEach(element => {
          this.localpermissionbuffer.push(element.id)
        })
        console.log('opening modal')
        console.log(this.selectedrole)
        console.log('localpermission buffer ', this.localpermissionbuffer)
        this.form.setFieldsValue(editData)
        this.spinning = false
        this.loading = false
      })
    },
    handleEdit: function (e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        const localpermissionbufferRemovedModuleIds = this.localpermissionbuffer.filter(item => {
          if (!(typeof item === 'string')) { // this will removes 'module_id_' prefixed items
            return item
          }
        })
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to update ${values.name}?`,
            content: `Click on the OK button to update the detail!`,
            onOk: () => {
              this.$http
                .post('/api/school-role/' + this.roleTypeId, {
                  name: values.name,
                  status: values.status ? '1' : '0',
                  slug: values.slug,
                  description: values.description,
                  permissions: localpermissionbufferRemovedModuleIds,
                })
                .then(() => {
                  this.$emit('edited')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Successfully edited',
                    description: 'Role details edited successfully!',
                  })
                  this.selectedrole = []
                  this.statuscheck = true
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }
      })
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
  },
}
</script>
